/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { cssFunc } from "../../../helpers/cssHelper";
import { memo } from "react";

/* 
  Wrapper for the cssFunc with some other props for ease of use (onClick, className, children) 
*/
export const PieceSpacer = memo(
	({
		children,
		className = "",
		onClick = () => null,
		type = "",
		width_scale = 0,
		height_scale = null,
		top_scale = 0,
		left_scale = 0,
		z_index = 0,
		zoom = 0,
		empty = true,
		spacing_scale = 0,
		noWidth = false,
		noHeight = false,
	}) => {
		return (
			<div
				onClick={onClick}
				className={`${className} relative`}
				css={cssFunc({
					type,
					widthScale: width_scale,
					heightScale: height_scale,
					topScale: top_scale,
					leftScale: left_scale,
					zIndex: z_index,
					zoom,
					spacing: spacing_scale,
					empty,
					noWidth,
					noHeight,
				})}
			>
				{children}
			</div>
		);
	}
);
